<template>
  <div class="button-group">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.button-group {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.75em;
}
</style>
